// src/components/DataAndInsights.js
import React from "react";
import './DataAndInsights.css'
import '../components/ProductsHeroBanner';
import ProductHeroBanner from "../components/ProductsHeroBanner";
import Navbar from '../components/Navbar'
//import Solutions from "../components/Solutions";
//import dataAndInsightsSolutionsData from "../components/dataAndInsightsSolutionsData";
import Footer from "../components/Footer";
import ContentBlocks from "../components/ContentBlocks";
import CallToAction from "../components/CallToAction";
import { Helmet } from "react-helmet";

const DataAndInsights = () => {

    const pageData = {
        heading: "Data & Insights Features",
        blocks: [
            {
                blockHeading: "Analytics for Practice Growth",
                text: "Monitor real-time performance on key metrics such as website search rankings, online reputation, and new patient appointments, all from one dashboard."
            },
            {
                blockHeading: "Revenue Performance Analysis",
                text: "Analyze revenue performance across practices, understanding key indicators at a glance or diving deep into reports for detailed insights, uncovering opportunities to improve your bottom line."
            },
            {
                blockHeading: "Enhanced Dashboard",
                text: "Doclivo provides a quality dashboard and guided workflows to easily track performance, enabling you to manage population health with actionable data at your fingertips."
            },
           
        ]
    };

    return (
        <>
            <Helmet>
                <title>DataAndInsights - Doclivo</title>
                <meta name="description" content="Learn more about Your Company Name, the leading provider of automation and optimization solutions." />
                <meta name="keywords" content="about us, company, automation" />
            </Helmet>
            <Navbar></Navbar>
            <section className="data-and-insights-section">
                <div className="data-and-insights-container">
                    <h5 className="data-and-insights-subheading">Empower Your Practice with Data-Insights</h5>
                    <h1 className="data-and-insights-main-heading">Unlock valuable data and insights to drive informed decisions and improve performance. Gain actionable insights from comprehensive data analysis.</h1>
                </div>

                <ProductHeroBanner></ProductHeroBanner>

                <ContentBlocks
                    heading={pageData.heading}
                    subheading={pageData.subheading}
                    blocks={pageData.blocks}
                />
                <CallToAction></CallToAction>
            </section>
            <Footer></Footer>
        </>
    );
};

export default DataAndInsights;